module.exports = __webpack_public_path__ + "static/05-f88655ed4350b81bd3511a0726fccd81.jpg";